'use client'

import { useTranslations } from '@/lib/next-shim'

import { Typography } from '@mui/material'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'

import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { useCustomFormWithReset } from '@/hooks/useCustomFormWithReset'

import { contactInfo, contactInfoFormData, getParentDefaultValues } from '../model/profileForms'
import { ProfileAccordion } from './ProfileAccordion'

export function EmergencyContactSection() {
  const t = useTranslations()
  const { data } = useGetMyInfosQuery()
  const parents = data?.myInfos?.parents

  useCustomFormWithReset<contactInfoFormData[], typeof parents>(parents, getParentDefaultValues, contactInfo)

  return (
    <ProfileAccordion icon={<PhoneOutlinedIcon sx={{ color: 'primary.dark' }} />} title={t('page.AccountSettings.profile.emergencyContact')}>
      <Typography variant="body2" color="text.secondary">
        {t('page.AccountSettings.other.subtitle')}
      </Typography>
    </ProfileAccordion>
  )
}
